export function generateReviewRow(){
    return `<div class="customer-review-list hydrated">
                <div class="reviews"></div>
            </div>`
}